import React from "react";
import './Fauna.css';

import SiYourtraveldottv from "../image/SiYourtraveldottv.png";
import fundofolha from "../image/fundofolha.jpg";
import a1 from "./img/a1.JPG";
import a2 from "./img/a2.jpg";
import a3 from "./img/a3.jpg";
import Header from "../components/Header";


const Fauna = () => { 
  const handleGoBack = () => {
      window.history.back(); // Volta à página anterior
    };
  return (
    <div className="fauna-container">
     
     <Header/>

    <div className="fauna-header">
      <h1>Fauna</h1>
      <p>Oferecemos uma ampla gama de serviços para promover a sustentabilidade e biodiversidade.</p>
    </div>
    <div className="conteudo-grid">
     
      <div className="conteudo-card">
      <img
                              src={a1}
                              alt="Laudo Técnico"
                              style={{
                                width: "100%", // Largura total do card
                                height: "auto", // Proporção da imagem
                                objectFit: "cover", // Ajusta a imagem para preencher o espaço
                              }}
                            />
        <h3>Planos de Manejo da Fauna em Aeródromos (PMFA)</h3>
        <p>Desenvolvemos planos de manejo e soluções personalizadas para preservação ambiental.</p>
      </div>
      <div className="conteudo-card">
    <img
                            src={a2}
                            alt="Laudo Técnico"
                            style={{
                              width: "100%", // Largura total do card
                              height: "auto", // Proporção da imagem
                              objectFit: "cover", // Ajusta a imagem para preencher o espaço
                            }}
                          />
        <h3>Resgate, Afugentamento e Monitoramento de Fauna</h3>
        <p>Implementação de estratégias para restaurar ecossistemas degradados e promover a biodiversidade.</p>
      </div>
      <div className="conteudo-card">
        <img
                                src={a3}
                                alt="Laudo Técnico"
                                style={{
                                  width: "100%", // Largura total do card
                                  height: "auto", // Proporção da imagem
                                  objectFit: "cover", // Ajusta a imagem para preencher o espaço
                                }}
                              />
        <h3>Restauro Ecológico</h3>
        <p>Implementação de estratégias para restaurar ecossistemas degradados e promover a biodiversidade.</p>
      </div>
    </div>
    <div className="back-button-container">
    <button onClick={handleGoBack} className="back-button"   > <i class=" fas fa-solid fa-arrow-left"></i>
      Outros serviços
    </button>
    
  </div>
  <section class="footer" style={{
   background: `linear-gradient(rgba(255, 255, 255, 0.5), rgba(138, 138, 138, 0.5)), url(${fundofolha})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    
    
    color: "#fff" // Para contrastar o texto com o fundo
  }}>
        <div class="box-container">
          <div class="box">
            <h3>Navegue</h3>
            <a href="#">
              {" "}
              <i class="fas fa-chevron-right"></i> Início{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-chevron-right"></i> Sobre{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-chevron-right"></i> Serviços{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-chevron-right"></i> Equipe{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-chevron-right"></i> Iniciar conversa{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-chevron-right"></i> Avaliações{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-chevron-right"></i> Blog{" "}
            </a>
          </div>

          <div class="box">
            <h3>Nossos serviços</h3>
            <a href="#">
              {" "}
              <i class="fas fa-chevron-right"></i> Florestal{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-chevron-right"></i>  Fauna{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-chevron-right"></i> Propriedade Intelectual{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-chevron-right"></i> Laudos e Pareceres Técnicos{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-chevron-right"></i> Levantamentos{" "}
            </a>
          </div>

          <div class="box">
            <h3>Contato </h3>
            <a href="#">
              {" "}
              <i class="fas fa-phone"></i> (34) 9 9920-3789{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-phone"></i> (11) 9 8632-1639{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-envelope"></i> emerson@biolinksolucoes.com.br{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-envelope"></i> omar.neto@biolinksolucoes.com.br{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fas fa-map-marker-alt"></i> Uberlândia, Minas Gerais {" "}
            </a>
          </div>

          <div class="box">
            <h3>Conecte-se conosco!</h3>
            <a href="#">
              {" "}
              <i class="fab fa-facebook-f"></i> facebook{" "}
            </a>
          
            <a href="#">
              {" "}
              <i class="fab fa-instagram"></i> instagram{" "}
            </a>
            <a href="#">
              {" "}
              <i class="fab fa-linkedin"></i> linkedin{" "}
            </a>
           
          </div>
        </div>

        <div class="credit">
          {" "}
          Criado por{" "}
          <span>
            <a href="https://instagram.com"> Biolink </a>
          </span>{" "}
          | ©Todos os direitos reservados.{" "}
        </div>
      </section>
  </div>
  
  );
};

export default Fauna;